<script module>
  export const meta = {
    title: 'Start onboarding your staff',
    teaser:
      'Learn how to add members to your organization using "Allowed Email Domains" for\nstreamlined onboarding or add them individually for specific use cases.',
    sort: 1,
  }
</script>

<p>
  Creating an organization is a significant step, but it's the members within
  that bring it to life and make it functional. To populate your organization
  efficiently, there are two primary methods for adding members:
</p>
<h3>1. Set "Allowed Email Domains" (Recommended)</h3>
<p>
  This method is straightforward and highly efficient, particularly for larger
  organizations. By setting allowed email domains, anyone with a company email
  address will be able to join the organization automatically. This not only
  streamlines the process but also maintains security by ensuring only
  individuals with company email addresses can gain access.
</p>
<p>
  To activate this, you (or another member you've already added to the
  organization) must have an email belonging to the domain you wish to allow.
  You can find this option in the "Members" section of your organization page on
  the platform. After it's set, users signing up with a company email belonging
  to the allowed domain will be automatically added to the organization.
</p>
<p>
  <strong>Note:</strong> In cases where users haven't initially signed up with their
  company email address, there's still a seamless way for them to join. They can navigate
  to the organization page and click on the "Join organization" button. This sends
  a confirmation email to their company address, facilitating their addition without
  any extra steps on your part.
</p>
<h3>2. Add Them Individually</h3>
<p>
  For situations where an organization doesn't rely on a unified email domain,
  or if there's a need to add users who don't have a company email address
  (freelancers, consultants, etc.), members can be added manually. In this case,
  request the username from the individual you wish to add. Once obtained, you
  can easily add them to the organization from your end.
</p>
<p>
  Both methods have their place depending on your organization's size and the
  nature of your team. By choosing the one that best fits your needs, you'll
  ensure a smooth and hassle-free process in building your organization's
  membership.
</p>
